require('./modifyLimitStep1.scss');

const PropTypes = require('prop-types');

//@vendor
const React = require('react');
const { connect } = require('react-redux');

//@components
const CardModifyLimitInformativeSection = require('components/cards/cardModifyLimit/cardModifyLimitInformativeSection/cardModifyLimitInformativeSection');
const CardModifyLimitSliderSection = require('components/cards/cardModifyLimit/cardModifyLimitSliderSection/cardModifyLimitSliderSection');
const CardModifyLimitModalSection = require('components/cards/cardModifyLimit/cardModifyLimitModalSection/cardModifyLimitModalSection');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { AFISimulator } = require('components/cards/AFISimulator/AFISimulator');

//@helpers
const { FormattedText } = require('core/i18n').i18n;

//@constants
const { FIRST_STEP } = require('constants/index');
const { CARD_PAYMENT_METHOD_UNIQUE } = require('constants/index');
const { REVOLVING_AFI_MODIFY_LIMIT } = require('constants/flagBasedFeatures');

//@actions
const cardChangePaymentMethodActions = require('actions/cardChangePaymentMethod');

class ModifyLimitStep1 extends React.Component {
    constructor(props) {
        super(props);
        const { immCardModifyLimit } = this.props;
        const immStepOne = immCardModifyLimit.getIn(['steps', FIRST_STEP]);
        const choosenLimit = immStepOne.get('tentativeLimit');
        const originalLimit = immStepOne.get('currentLimit');

        this.state = {
            limit: choosenLimit || originalLimit,
            limitHasChanged: originalLimit !== choosenLimit,
        }
    }

    componentDidMount() {
        const { immCard, requestPaymentMethodInfo } = this.props;

        requestPaymentMethodInfo(immCard.get('cardId'));
    }

    buildDisclaimer() {
        const {
            immCard,
            showIneAndRevolving,
        } = this.props;
        const isForRevolvingProcess = immCard.get('isForRevolvingProcess');
        const isRender = showIneAndRevolving && isForRevolvingProcess && __CONTACT_CENTER__;

        return !!isRender && (
            <BlockInfo extraClass="cancel-bizum-step1__block-info">
                <span>
                    <FormattedText value="modifyLimitStep1-modifyLimitStep1_fotterInfoCC"/>
                </span>
            </BlockInfo>
        )
    }

    isCardForRevolving() {
        const { immCard, showIneAndRevolving } = this.props;
        const isForRevolvingProcess = immCard.get('isForRevolvingProcess');
        return isForRevolvingProcess && showIneAndRevolving;
    }

    isPaymentMethodUnique(method) {
        return method === CARD_PAYMENT_METHOD_UNIQUE;
    }

    onLimitChange (limit) {
        this.setState({limit,limitHasChanged: true});
        this.props.handleLimitChange(limit);
    }

    render() {
        const {
            handleCloseModal,
            handleModalContinueButtonClick,
            immCard,
            immCardChangePaymentMethod,
            immCardModifyLimit,
            immFlagBasedFeatures,
            immGlobalVariables,
            isLimitInvalid,
        } = this.props;

        let sliderSection = <LoadingSection />;
        const immStepOne = immCardModifyLimit.getIn(['steps', FIRST_STEP]);
        const currency = immStepOne.get('currency');

        const suggestedAmount = {
            amount: immStepOne.get('suggestedAmount', 0),
            currency
        };

        const modalPendingAmount = {
            amount: immStepOne.get('tentativeLimit'),
            currency
        };

        const titleKey = immCard.get('isViaT') ? 'cardModifyLimitInformativeSection-stepOneTitleViaT' : 'cardModifyLimitInformativeSection-stepOneTitle';
        
        let AFISimulatorSection = null;

        if (immCardChangePaymentMethod){
            const method = immCardChangePaymentMethod.getIn(['steps', '0', 'currentPaymentMethod']);
            const installments = immCardChangePaymentMethod.getIn(['steps', '0', 'installments']);
            const showAFISimulator = immFlagBasedFeatures.get(REVOLVING_AFI_MODIFY_LIMIT) && this.state.limitHasChanged && this.isCardForRevolving() && !this.isPaymentMethodUnique(method);
            AFISimulatorSection = showAFISimulator && (
                <AFISimulator
                    amount={this.state.limit}
                    immCard={immCard}
                    immGlobalVariables={immGlobalVariables}
                    installments={installments}
                    method={method}
                />
            )
        }

        if (!immCardModifyLimit.get('isFetching')) {
            const availableLimits = immCardModifyLimit.get('limits');
            sliderSection = (
                <CardModifyLimitSliderSection
                    availableLimits={availableLimits}
                    currency={currency}
                    defaultLimit={immStepOne.get('tentativeLimit')}
                    handleLimitChange={(limit) => this.onLimitChange(limit)}
                    immCard={immCard}
                    isLimitInvalid={isLimitInvalid}
                    maximumLimit={immCardModifyLimit.get('maximumLimit')}
                    minimumLimit={immCardModifyLimit.get('minimumLimit')}
                />
            );
        }

        return (
            <article className="modify-limit-step-one">
                <CardModifyLimitModalSection
                    handleCancel={handleCloseModal}
                    handleContinue={handleModalContinueButtonClick}
                    isOpen={immStepOne.get('shouldShowModal')}
                    pendingAmount={modalPendingAmount}
                    suggestedAmount={suggestedAmount}
                />
                <CardModifyLimitInformativeSection immCard={immCard} titleKey={titleKey} />
                {sliderSection}
                {AFISimulatorSection}
                {this.buildDisclaimer()}
            </article>
        );
    }
}

ModifyLimitStep1.propTypes = {
    immCard: PropTypes.object,
    immCardChangePaymentMethod: PropTypes.object.isRequired,
    immCardModifyLimit: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    handleLimitChange: PropTypes.func,
    handleCloseModal: PropTypes.func.isRequired,
    handleModalContinueButtonClick: PropTypes.func.isRequired,
    requestPaymentMethodInfo: PropTypes.func.isRequired,
    setUpStep: PropTypes.func.isRequired,
    isLimitInvalid: PropTypes.bool.isRequired,
    showIneAndRevolving: PropTypes.bool.isRequired,
};

module.exports.constructor = ModifyLimitStep1;
module.exports.ModifyLimitStep1 = connect(
    state => ({
        immCardChangePaymentMethod: state.cardChangePaymentMethod,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
    }),
    {
        requestPaymentMethodInfo: cardChangePaymentMethodActions.requestPaymentMethodInfo,
    }
)(ModifyLimitStep1);
